import { get, post, destroy, patch } from "utils/FetchAPI";

export const getInformation = (query) => get("/information", { ...query});
export const getInformationClient = (query) => get("/information/data", { ...query});
export const createInformation = (data) => post("/information", { ...data, team_id: localStorage.getItem("currentTeamId") });

export const updateInformation = (data,informationId) => patch(`/information/${informationId}`, { ...data, team_id: localStorage.getItem("currentTeamId") });
export const deleteInformation = (informationId) => destroy(`/information/${informationId}`);
